'use strict';

angular.module('lingApp')
  .factory('RipServer', function($rootScope, $compile, $window, $document, $http, $q, $location, $cacheFactory, $timeout, i18n, RipContext, JsonErrorCode, RipDialog) {
    var RipServer = { cache: $cacheFactory('ripServerPostRequestCache'),
                      downloadFormScope: null
                    };

    function exec(url, data, config) {
      var request = {};
      request.currentClientId = RipContext.currentClient && RipContext.currentClient.id;
      request.currentLoginName = RipContext.loginName;
      request.ring = true;
      request.data = data || {};

      return (config && config.cache
              ? execWithCache(url, request, config)
              : post(url, request, config));
    }

    function execWithCache(url, request, config) {
      var defer = $q.defer();
      var cacheRepository = angular.isObject(config.cache) ? config.cache : RipServer.cache;

      var cacheList = cacheRepository.get(url);
      if (!cacheList) {
        cacheList = [];
        cacheRepository.put(url, cacheList);
        delete config.cachedData;
      }

      var cache = _.find(cacheList, function(cache) {
        return angular.equals(cache.request, request);
      });

      if (!cache) {
        cache = { data: undefined,
                  request: request,
                  pendings: undefined };
        cacheList.push(cache);
      }

      if (angular.isDefined(cache.data)) {
        if (!config.cachedData) {
          config.cachedData = (config.transformResponse
                               ? config.transformResponse(cache.data)
                               : cache.data);
        }
        defer.resolve(config.cachedData);

      } else if (cache.pendings) {
        cache.pendings.push({ defer: defer, config: config });

      } else {
        cache.data = undefined;
        cache.pendings = [{ defer: defer, config: config }];

        post(url, request).then(function onSuccess(data) {
          cache.data = data;

          angular.forEach(cache.pendings, function(pending) {
            pending.config.cachedData = (pending.config.transformResponse
                                         ? pending.config.transformResponse(data)
                                         : data);
            pending.defer.resolve(pending.config.cachedData);
          });

          delete cache.pendings;

        }, function onFailure(reason) {
          angular.forEach(cache.defers, function(resolve) {
            resolve.reject(reason);
          });

          delete cache.pendings;
        });
      }

      return defer.promise;
    }

    function post(url, requestData, config, defer) {
      if (!angular.isDefined(defer)) {
        defer = $q.defer();
      }

      var request = { url: url,
                      requestData: requestData,
                      config: config || {},
                      defer: defer };

      RipContext.windRequest();

      $http
        .post(url, requestData)
        .then((response) => {
          const data = response.data;
          const status = response.status;
          const headers = response.headers;
          const config = response.config;
          RipContext.unwindRequest();
          RipContext.windRequestCompletion();

          try {
            switch (status) {
            case 200:
              if (!angular.isObject(data) || _.isEmpty(data)) {
                handleNetworkError(request);

              } else if (data.error) {
                handleErrorResponse(data.error, request);

              } else {
                handleOkResponse(data, request);
              }

              break;

            case 403:
              handleSessionTimeOut(request);
              break;

            default:
              handleErrorResponse({ status: status,
                                    message: i18n('Server is currently not available. Please try again in a few minutes.'),
                                    data: data },
                                  request);
            }
          } finally {
            RipContext.unwindRequestCompletion();
          }
        },
              function(data, status, headers, config) {
                RipContext.unwindRequest();

                switch (status) {
                case 0:
                  RipDialog.warn(i18n('Server is not available. Please try again in a few minutes.'));
                  defer.reject({status: status, message: i18n('Server is not available. Please try again in a few minutes.')});
                  break;

                case 403:
                  handleSessionTimeOut(request);
                  break;

                default:
                  RipDialog.warn(i18n('Server Error. Http Response Code: {0}', status));
                  defer.reject({status: status, message: i18n('Server Error')});
                }
              }
             );

      return defer.promise;
    }

    function submit(path, data, config) {
      var scope = RipServer.downloadFormScope;

      if (null === scope) {
        scope = (RipServer.downloadFormScope = $rootScope.$new());

        angular
          .element($document[0].body)
          .append($compile('<rip-form-submission style="display:none"'
                           +                   'method="post"'
                           +                  'enctype="{{encoding}}"'
                           +                   'action="{{action}}">'
                           + '<input type="hidden" name="currentClientId" value="{{currentClientId}}"/>'
                           + '<input type="hidden" name="currentLoginName" value="{{currentLoginName}}"/>'
                           + '<input type="hidden" name="ring" value="true"/>'
                           + '<input type="hidden" name="data" value="{{data}}"/>'
                           + '</rip-form-submission>')(scope));
        scope.$on('RipFormSubmitCompleted', function(event, data) {
          event.stopPropagation();

          if (data) {
            var message = null;

            try {
              var json = angular.fromJson(data);

              if (angular.isObject(json)) {
                message = json.message;

                if (angular.isObject(json.data)) {
                  message = json.data.message;
                }
              }

            } catch (e) {
              console.log('error', e);
            }

            RipDialog.warn(message || i18n('Server Error'));
          }
        });
      }

      scope.encoding = config && config.encoding || 'multipart/form-data';
      scope.action = path;
      scope.currentClientId = RipContext.currentClientId;
      scope.currentLoginName = RipContext.loginName;
      scope.data = angular.toJson(data);
      scope.$broadcast('RipFormSubmit');
    }

    function handleOkResponse(data, request) {
      RipContext.applicationMessage = data.application;
      request.defer.resolve(request.config.transformResponse
                            ? request.config.transformResponse(data.result)
                            : data.result);
    }

    function handleNetworkError(request) {
      $window.alert('Network Error. Click OK to retry.');
      post(request.url, request.requestData, request.config, request.defer);
    }

    function handleSessionTimeOut(originalRequest) {
      refreshApplication();
    }

    function handleErrorResponse(error, request) {
      switch (error.code) {
      case JsonErrorCode.BAD_SESSION:
        handleSessionTimeOut(request);
        break;

      case JsonErrorCode.SESSION_CLIENT_MISMATCH:
        refreshApplication(error.message);
        break;

      case JsonErrorCode.SSO_REDIRECT:
        $window.location.replace(error.data.url);
        break;

      case JsonErrorCode.PASSWORD_EXPIRED:
        if ($window.confirm(i18n('Password is expired. Please click OK to reset password'))) {
          const params = new URLSearchParams(window.location.search);
          if (error.data) {
            _.forEach(error.data, (value, key) => {
              params.set(key, value);
            });
          }
          $window.location.replace('/rip/launch/resetPassword?' + params.toString());
        }
        break;

      case JsonErrorCode.PARSE_ERROR:
      case JsonErrorCode.INVALID_REQUEST:
      case JsonErrorCode.METHOD_NOT_FOUND:
      case JsonErrorCode.INVALID_PARAMS:
      case JsonErrorCode.INTERNAL_ERROR:
      case JsonErrorCode.APPLICATION_ERROR:
      case JsonErrorCode.SYSTEM_ERROR:
      case JsonErrorCode.TRANSPORT_ERROR:
      case JsonErrorCode.SERVER_ERROR:
      case JsonErrorCode.INSUFFICIENT_PRIVILEGES:
        if (error.message) {
          RipDialog.warn(error.message
                         + (error.data && error.data.message
                            ? (': ' + error.data.message)
                            : ''));
        }
        request.defer.reject(error);
        break;

      case JsonErrorCode.VALIDATION_ERROR:
        if (error.data && 'Cannot save' === error.message) {
          var keys = _.keys(error.data);
          if (1 === keys.length && error.data[keys[0]] === keys[0]) {
            error.message = keys[0];
            error.data = {};
          }
        }

        if (error.data
            && error.data.message
            && 'Validation Error' === error.message) {
          error.message = error.data.message;
        }

        request.defer.reject(error);
        break;

      default:
        request.defer.reject(error);
      }
    }

    function refreshApplication(message) {
      if ($window.confirm(message || i18n('Application might not be up to date. Click OK to restart.'))) {
        $window.location.reload(true);
      }
    }

    return {
      exec: function(url, data, config) {
        return exec(url, data, config);
      },

      resolve: function(url, config) {
        return function(data) {
          return exec(url, data, config);
        };
      },

      download: function(url, data, config) {
        submit(url, data, config);
      },

      wait: function(url, message) {
        var dialog = RipDialog.wait(message);
        var server = this;

        function check() {
          server.exec(url).then(function(result) {
            if (result.isProcessing) {
              $timeout(check, 1000);
            } else {
              dialog.dismiss();
            }
          });
        }

        $timeout(check, 1000);
      },

      clearCache: function(url) {
        RipServer.cache.remove(url);
      }
    };
  });
